/**
 * @fileoverview gRPC-Web generated client stub for contact
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: protobuf/contact/contact.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as protobuf_contact_contact_pb from '../../protobuf/contact/contact_pb';
import * as protobuf_model_merged_pb from '../../protobuf/model/merged_pb';


export class ContactServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreate = new grpcWeb.MethodDescriptor(
    '/contact.ContactService/Create',
    grpcWeb.MethodType.UNARY,
    protobuf_contact_contact_pb.CreateContactRequest,
    protobuf_model_merged_pb.ContactResponse,
    (request: protobuf_contact_contact_pb.CreateContactRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.ContactResponse.deserializeBinary
  );

  create(
    request: protobuf_contact_contact_pb.CreateContactRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.ContactResponse>;

  create(
    request: protobuf_contact_contact_pb.CreateContactRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.ContactResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.ContactResponse>;

  create(
    request: protobuf_contact_contact_pb.CreateContactRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.ContactResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/contact.ContactService/Create',
        request,
        metadata || {},
        this.methodDescriptorCreate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/contact.ContactService/Create',
    request,
    metadata || {},
    this.methodDescriptorCreate);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/contact.ContactService/Update',
    grpcWeb.MethodType.UNARY,
    protobuf_contact_contact_pb.UpdateContactRequest,
    protobuf_model_merged_pb.ContactResponse,
    (request: protobuf_contact_contact_pb.UpdateContactRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.ContactResponse.deserializeBinary
  );

  update(
    request: protobuf_contact_contact_pb.UpdateContactRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.ContactResponse>;

  update(
    request: protobuf_contact_contact_pb.UpdateContactRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.ContactResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.ContactResponse>;

  update(
    request: protobuf_contact_contact_pb.UpdateContactRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.ContactResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/contact.ContactService/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/contact.ContactService/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/contact.ContactService/Get',
    grpcWeb.MethodType.UNARY,
    protobuf_contact_contact_pb.GetContactsRequest,
    protobuf_contact_contact_pb.GetContactsResponse,
    (request: protobuf_contact_contact_pb.GetContactsRequest) => {
      return request.serializeBinary();
    },
    protobuf_contact_contact_pb.GetContactsResponse.deserializeBinary
  );

  get(
    request: protobuf_contact_contact_pb.GetContactsRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_contact_contact_pb.GetContactsResponse>;

  get(
    request: protobuf_contact_contact_pb.GetContactsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_contact_contact_pb.GetContactsResponse) => void): grpcWeb.ClientReadableStream<protobuf_contact_contact_pb.GetContactsResponse>;

  get(
    request: protobuf_contact_contact_pb.GetContactsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_contact_contact_pb.GetContactsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/contact.ContactService/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/contact.ContactService/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorDelete = new grpcWeb.MethodDescriptor(
    '/contact.ContactService/Delete',
    grpcWeb.MethodType.UNARY,
    protobuf_contact_contact_pb.DeleteContactsRequest,
    protobuf_contact_contact_pb.DeleteContactsResponse,
    (request: protobuf_contact_contact_pb.DeleteContactsRequest) => {
      return request.serializeBinary();
    },
    protobuf_contact_contact_pb.DeleteContactsResponse.deserializeBinary
  );

  delete(
    request: protobuf_contact_contact_pb.DeleteContactsRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_contact_contact_pb.DeleteContactsResponse>;

  delete(
    request: protobuf_contact_contact_pb.DeleteContactsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_contact_contact_pb.DeleteContactsResponse) => void): grpcWeb.ClientReadableStream<protobuf_contact_contact_pb.DeleteContactsResponse>;

  delete(
    request: protobuf_contact_contact_pb.DeleteContactsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_contact_contact_pb.DeleteContactsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/contact.ContactService/Delete',
        request,
        metadata || {},
        this.methodDescriptorDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/contact.ContactService/Delete',
    request,
    metadata || {},
    this.methodDescriptorDelete);
  }

  methodDescriptorList = new grpcWeb.MethodDescriptor(
    '/contact.ContactService/List',
    grpcWeb.MethodType.UNARY,
    protobuf_contact_contact_pb.ListContactsRequest,
    protobuf_contact_contact_pb.ListContactsResponse,
    (request: protobuf_contact_contact_pb.ListContactsRequest) => {
      return request.serializeBinary();
    },
    protobuf_contact_contact_pb.ListContactsResponse.deserializeBinary
  );

  list(
    request: protobuf_contact_contact_pb.ListContactsRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_contact_contact_pb.ListContactsResponse>;

  list(
    request: protobuf_contact_contact_pb.ListContactsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_contact_contact_pb.ListContactsResponse) => void): grpcWeb.ClientReadableStream<protobuf_contact_contact_pb.ListContactsResponse>;

  list(
    request: protobuf_contact_contact_pb.ListContactsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_contact_contact_pb.ListContactsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/contact.ContactService/List',
        request,
        metadata || {},
        this.methodDescriptorList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/contact.ContactService/List',
    request,
    metadata || {},
    this.methodDescriptorList);
  }

}

